<template>
  <div class="vieo-filter vidfitr">
    <div class="vidfitr_rows">
      <div>
        <div style="color: var(--clr-grey-2); margin-bottom: 0.25rem; font-size: 0.875rem">
          {{ $t('common.coaches') }}
        </div>

        <div class="cc_checkbox-row">
          <Checkbox
            :asBtn="true"
            :value="!vid_coaches.selected"
            @click="handleUnUpdate('')"
          >
            {{ $t('common.any') }}
          </Checkbox>
          <UnSwitcherNew
            :hasText="true"
            class="w-100 z-index_3"
            :style="`

              --uns-opener-clr-back: ${
                !!vid_coaches.selected ? 'var(--clr-black-4)' : 'transparent'
              };
              --uns-opener-height: calc(2rem + 2px);
              max-width: 14.5rem;
              min-width: 14.5rem;
              font-size: 1rem;
              `"
            :tab="vid_coaches.selected || vid_coaches.options[0].payload"
            :options="vid_coaches.options"
            @click="handleUnUpdate"
          >
          </UnSwitcherNew>
        </div>
      </div>

      <CheckboxRow
        class="vidfitr_checkbox-rows"
        :item="vid_formats"
        style="--clr-row-back: var(--clr-black-1-2)"
        :checkboxAs="'btn'"
        :isSingle="true"
        @update="handleUpdate"
      >
        <template #default="v">
          {{ v.id === 'theory' ? $t(`common.theory`) : $t(`gametypes.groups.${v.id}`) }}
        </template>
      </CheckboxRow>

      <CheckboxRow
        class="vidfitr_checkbox-rows"
        :item="vid_show"
        style="--clr-row-back: var(--clr-black-1-2)"
        :checkboxAs="'btn'"
        :isSingle="false"
        :hasAny="true"
        @update="handleUpdate"
      >
        <template #default="v">
          {{ $t(`common.${v.id}`) }}
        </template>
      </CheckboxRow>

      <CheckboxRow
        class="vidfitr_checkbox-rows"
        :item="vid_order_date"
        style="--clr-row-back: var(--clr-black-1-2)"
        :checkboxAs="'btn'"
        :isSingle="true"
        :hasAny="false"
        @update="handleUpdate"
      >
        <template #default="v">
          <div
            class="mdi"
            style="line-height: 1"
            :class="v.id == 'desc' ? 'mdi-arrow-down' : 'mdi-arrow-up'"
          ></div>
        </template>
      </CheckboxRow>

      <div class="f-column flex-1">
        <div class="cherow_title gw_hvr">
          <div
            class="text-medium"
            style="color: var(--clr-grey-2); margin-bottom: 0.25rem"
          >
            {{ $t('common.search') }}
          </div>
        </div>

        <SearchBox
          :items="filteredItems"
          :style="{
            '--srch-input-border-color': 'var(--clr-black-3)',
            '--srch-input-border-focus-color': 'var(--clr-primary)',
          }"
        >
          <template #result="{ item }">
            <div class="truncate pr-2">
              {{ item.name }}
            </div>
            <div
              class="vidlist_tag ml-auto"
              :style="`--clr-tag:var(--clr-${item.format})`"
            >
              {{
                item.format === 'theory'
                  ? $t(`common.theory`)
                  : $t(`gametypes.groups.${item.format}`)
              }}
            </div>
          </template>
        </SearchBox>
      </div>
    </div>
    <div class="vidfitr_content">
      <slot
        :items="filteredItems"
        :sortOrder="sortOrder"
      />
    </div>
  </div>
</template>

<script>
import CheckboxRow from '@/components/Forms/CheckboxRow'
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import SearchBox from '@/components/lib/SearchBox'
import Checkbox from '@/components/Common/Checkbox/Checkbox'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'VideoFilter',
  components: {
    CheckboxRow,
    UnSwitcherNew,
    SearchBox,
    Checkbox,
  },
  mixins: [float_mix],
  props: {
    items: { default: () => [] },
  },
  emits: ['input'],
  data() {
    return {}
  },
  methods: {
    handleUnUpdate(item) {
      this.$router
        .replace({
          query: {
            ...this.$route.query,
            vid_coaches: item.payload,
          },
        })
        .catch(() => {})
    },
    handleUpdate(item) {
      this.$router
        .replace({
          query: {
            ...this.$route.query,
            [item.id]: item.selected.join(','),
          },
        })
        .catch(() => {})
    },
    emitData() {
      this.$emit('input', this.filteredItems)
    },
  },
  computed: {
    sortOrder() {
      return this.vid_order_date.selected[0]
    },
    filteredItems() {
      const vid_coaches = this.vid_coaches.selected?.length
      const vid_formats = this.vid_formats.selected.length
      const vid_show = this.vid_show.selected.length
      // const vid_favorite = this.vid_favorite.selected.length
      let res = this.pasTItem.filter(item => {
        const r =
          (vid_coaches ? this.vid_coaches.selected.includes(item.coach_id) : true) &&
          (vid_formats ? this.vid_formats.selected.includes(item.format.toLowerCase()) : true) &&
          (vid_show
            ? this.vid_show.selected.includes('favorite')
              ? item.is_favorite
              : true
            : true) &&
          (vid_show
            ? this.vid_show.selected.includes('not_watched')
              ? !item.is_watched
              : true
            : true)
        // console.log(item, this.vid_show.selected)
        return r
      })
      if (this.sortOrder === 'desc') {
        res = res.sort((a, b) => (a.datetime > b.datetime ? -1 : 1))
      } else {
        res = res.sort((a, b) => (a.datetime < b.datetime ? -1 : 1))
      }

      // console.log(res)
      // res = [...res, ...res, ...res]
      // res = [...res, ...res, ...res]
      // res.map((i, index) => ({ ...i, id: index }))

      return res
    },
    pasTItem() {
      const res = this.items.filter(item => item.is_past)
      return res
    },
    coachesNames() {
      const all = this.pasTItem.map(i => ({ nick: i.coach_name, id: i.coach_id }))
      const res = {}
      all.forEach(i => {
        res[i.id] = i.nick
      })
      return res
    },

    vid_coaches() {
      const all = this.pasTItem.map(i => i.coach_id)
      let options = [...new Set(all)]

      const urlAll = this.query.vid_coaches?.split(',').filter(i => i)
      const selected = (urlAll || []).filter(i => options.includes(i))

      options = options.map(i => ({
        payload: i,
        text: this.coachesNames[i],
      }))
      // debugger
      const res = {
        options,
        selected: selected[0],
      }
      // console.log(res)
      return res
    },
    vid_formats() {
      const all = this.pasTItem.map(i => i.format.toLowerCase())
      const options = [...new Set(all)]

      // console.log(this.items)

      const urlAll = this.query.vid_formats?.split(',').filter(i => i)
      const selected = (urlAll || []).filter(i => options.includes(i))
      const res = {
        id: 'vid_formats',
        title: this.$t('common.formats'),
        options,
        selected,
      }
      return res
    },
    vid_order_date() {
      // const all = this.pasTItem.map(i => i.format.toLowerCase())
      const options = ['desc', 'asc']

      const urlAll = this.query.vid_order_date?.split(',').filter(i => i)
      const selected = urlAll.length ? urlAll : ['desc']
      const res = {
        id: 'vid_order_date',
        title: this.$t('common.date'),
        options,
        selected,
      }
      return res
    },
    vid_show() {
      const options = ['favorite', 'not_watched']
      const urlAll = this.query.vid_show?.split(',').filter(i => i)
      const selected = (urlAll || []).filter(i => options.includes(i))
      const res = {
        id: 'vid_show',
        title: this.$t('common.show'),
        options,
        selected,
      }
      // console.log(res)
      return res
    },
    query() {
      const q = this.$route.query
      const res = {
        vid_coaches: q.vid_coaches || '',
        vid_formats: q.vid_formats || '',
        vid_order_date: q.vid_order_date || '',
        vid_show: q.vid_show || '',
        // vid_favorite: q.vid_favorite || '',
      }
      return res
    },
  },
  watch: {
    filteredItems: {
      immediate: true,
      handler: 'emitData',
    },
  },
}
</script>
<style lang="scss" scoped>
.vidlist_tag {
  border-radius: 4px;
  background: var(--clr-black-2);
  font-size: 0.8rem;
  color: var(--clr-white-0);
  padding: 0 0.25rem;
  min-height: 1.25rem;
  margin: 0.25rem 0.25rem 0.25rem 0;
  text-transform: uppercase;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  padding: 0 0.25rem 0 0.75rem;
  --clr-tag: red;
  &:before {
    content: '';
    height: 100%;
    width: 6px;
    position: absolute;
    background: var(--clr-tag);
    left: 0;
    top: 0;
  }
}

.vidfitr {
  width: 100%;
  &_rows {
    display: flex;
    flex-wrap: wrap;
    grid-gap: 1rem;
  }
}

@media (max-width: 1023px) {
  .vidfitr {
    &_rows {
      padding: 0 0.25rem;
      grid-gap: 0.25rem;
    }
  }
}
</style>
